<template>
  <v-card elevation="0">
    <v-card-subtitle class="px-1">Datos Tercero</v-card-subtitle>
    <v-card-text class="pa-0 ma-0">
      <v-form ref="form" lazy-validation>
        <v-row class="pa-0 ma-0">
          <v-col cols="12" md="2" class="pa-0 ma-0 px-1">
            <v-text-field
              v-model="placa"
              label="Placa"
              :rules="campoRequerido"
              clearable
              dense
              counter="25"
            ></v-text-field>
          </v-col>
          <v-col class="pa-0 ma-0 px-1">
            <v-text-field
              v-model="marca"
              label="Marca"
              :rules="campoRequerido"
              clearable
              dense
              counter="100"
            ></v-text-field>
          </v-col>
          <v-col class="pa-0 ma-0 px-1">
            <v-text-field
              v-model="modelo"
              label="Modelo"
              :rules="campoRequerido"
              clearable
              dense
              counter="100"
            ></v-text-field>
          </v-col>
          <v-col class="pa-0 ma-0 px-1">
            <v-text-field
              v-model="color"
              label="Color"
              :rules="campoRequerido"
              clearable
              dense
              counter="100"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="1" class="pa-0 ma-0 px-1">
            <v-text-field
              v-model="año"
              label="Año"
              :rules="campoRequerido"
              type="number"
              dense
              counter="25"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Axios from "axios";

export default {
  props: {
    numeroAsistencia: {
      type: String,
      required: true,
    },
    guardar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      placa: null,
      marca: null,
      modelo: null,
      año: null,
      color: null,
      campoRequerido: [(v) => !!v || "Requerido"],
    };
  },
  watch: {
    numeroAsistencia(val) {
      if (val) {
        this.refresh();
      }
    },
  },
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      if (this.numeroAsistencia) {
        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };

        Axios.get(`api/DatosTercero/${this.numeroAsistencia}`, configuracion)
          .then((res) => {
            this.placa = res.data.placa;
            this.marca = res.data.marca;
            this.modelo = res.data.modelo;
            this.año = res.data.año;
            this.color = res.data.color;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };

        Axios.put(
          `api/DatosTercero/${this.numeroAsistencia}`,
          {
            placa: this.placa,
            marca: this.marca,
            modelo: this.modelo,
            año: this.año,
            color: this.color,
          },
          configuracion
        ).catch((err) => {
          console.error(err);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
